import { memo } from 'react';
import { InputLabel, Stack } from '@mui/material';

import { useFormContext } from 'react-hook-form';
import PictureUploadForm from '@molecules/PictureUploadForm';
import { UPLOAD_PRESET } from '@modules/image-upload';

interface Props {
    description: string; // ex: 'Logo'
    fieldName: string; // ex: 'imageUrl'
    fileDisplayName?: string;
    presetType: UPLOAD_PRESET;
    uploadTags?: string[];
}

function ImageUpload({
    description,
    fieldName,
    fileDisplayName,
    presetType,
    uploadTags = [],
}: Props) {
    const { setValue, trigger, watch } = useFormContext();
    const imageURL = watch(fieldName);

    const htmlId = `${fieldName}-${description.replace(/\s/g, '')}-drag-drop`;

    return (
        <>
            <Stack direction="row" spacing={2} alignItems={'center'}>
                {imageURL ? (
                    <img
                        alt="image preview"
                        src={imageURL || ''}
                        style={{
                            margin: '1.5rem 0',
                            maxWidth: '20%',
                            minWidth: '250px',
                            border: '1px solid #888',
                        }}
                    />
                ) : null}

                <Stack display={'flex'} flexDirection={'column'}>
                    <InputLabel htmlFor={htmlId}>{description}</InputLabel>
                    <PictureUploadForm
                        htmlId={htmlId}
                        presetType={presetType}
                        fileDisplayName={fileDisplayName || description}
                        onUploadFinish={(fileInfo) => {
                            setValue(fieldName, fileInfo.secure_url, {
                                shouldDirty: true,
                                shouldTouch: true,
                                shouldValidate: true,
                            });
                            trigger(fieldName);
                        }}
                        uploadTags={uploadTags}
                    />
                </Stack>
            </Stack>
        </>
    );
}

export default memo(ImageUpload);
